/** @format */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FudisLanguageAbbr } from '@funidata/ngx-fudis/lib/types/miscellaneous';
import { LocalizedString } from 'common-typescript/types';
import { LocaleService } from 'sis-common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'div[sis-additional-info-details]',
    templateUrl: './additional-info-details.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class AdditionalInfoDetailsComponent implements OnInit {
    constructor(private localeService: LocaleService) {}

    @Input() data: LocalizedString;
    public providedLanguages: FudisLanguageAbbr[] = [];
    public selectedDescriptionLanguage: string;

    ngOnInit(): void {
        this.selectedDescriptionLanguage = this.localeService.getCurrentLanguage();

        if (this.data) {
            this.providedLanguages = Object.keys(this.data) as FudisLanguageAbbr[];
        }
    }

    changeLanguageBadgeContent(lang: FudisLanguageAbbr) {
        this.selectedDescriptionLanguage = lang;
    }
}
